import {
    CustomerTypes
} from '../ActionTypes/CustomerTypes';

class CustomerActions {

    static getCreateCustomer = payload => {
        return {
            type: CustomerTypes.GET_CREATE_CUSTOMER,
            payload: payload,
        };
    };

    static clearCreateCustomer = () => {
        return {
            type: CustomerTypes.CLEAR_CREATE_CUSTOMER,
        };
    };

}

export default CustomerActions;
